<app-inner-section-layout>
<app-title-bar [title]='title'></app-title-bar>

<br />

<div class="p-4 form-group d-flex form-line">
  <label class="col-sm-2 col-form-label message-heading" type="text">Document Name</label>
  <div class="col-sm-2">
    <input type="text" [(ngModel)]="fileName">
  </div>
  <div class="col-sm-4 end">
    <button class="btn btn-action-primary text-nowrap me-3" (click)="getData()">
      <em class="fas fa-filter me-2" aria-hidden="true"></em>Filter
    </button>
  </div>
</div>
<div class="board">
  <div>
    <app-data-grid [elements]="elements" [elementsMeta]="elementsMeta" [gridHeight]="450" [heightOffset]="185" haveDocumentsLinks="true"
      (handleCellClickEvent)="handleCellClickEvent($event)">
    </app-data-grid>
    </div>
    <div></div>
</div>
<ng-template #downloadFile></ng-template>
</app-inner-section-layout>
